module.exports = __webpack_public_path__ + "img/empty_cr.ca58ab49.svg";